export default __webpack_public_path__ + "css/register.bundle.css";